import type { FormattedCompanyDetails } from "components/job/JobLayout/JobCompanyDetails/helpers";
import { formatCustomer } from "components/job/JobLayout/JobCustomerDetails/helpers";
import { useSelector } from "react-redux";
import jobSelectors from "store/selectors/job";

export type JobCustomerDetailsPropsHook = FormattedCompanyDetails;

export default function useJobCustomerDetailsProps(): JobCustomerDetailsPropsHook {
  const job = useSelector(jobSelectors.getEntity);
  return formatCustomer(job?.customer);
}
